import React, { useState, useEffect } from 'react';
import { Button, Card, Modal, Tabs, Tab } from 'react-bootstrap';
import { FiClock, FiDownload } from 'react-icons/fi';
import ReactMarkdown from 'react-markdown';
import IconExcel from "../../../../images/icon-risk.png";
import { LuDownload } from "react-icons/lu"; import axios from "axios";
import apiConfig from "../../../credentials/apiConfig";
import { toast } from "react-toastify";
import './styles.scss'


const AnalysisResults = ({ analysisData, flaggedPointsData, onViewHistory, onDownload, selectedDocument }) => {
  const [currentTab, setCurrentTab] = useState('summary');

  if (!analysisData) {
    return (
      <div className="d-flex justify-content-center align-items-center h-100">
        <p className="text-muted">No analysis data available yet.</p>
      </div>
    );
  }

  // Determine if we have flagged points data available
  const hasFlaggedPoints =
    (Array.isArray(flaggedPointsData) && flaggedPointsData.length > 0) ||
    (analysisData && analysisData.rawFlaggedPoints && analysisData.rawFlaggedPoints.trim() !== "");

  // Improved check for download button
  const canDownload = selectedDocument && selectedDocument.fileKey && selectedDocument.fileKey.trim() !== "";

  return (
    <div className="d-flex flex-column h-100">
      <Card className='mb-4'>
        <Card.Body className='d-flex justify-content-end align-items-center'>
          <div className="d-flex gap-2">
            <Button
              variant="primary"
              onClick={onDownload}
              disabled={!canDownload}
              title={!canDownload ? "Please select a document first" : "Download document"}
              className='my-auto'
            >
              <LuDownload className='text-white fw-bold' size={18} /> Download
            </Button>

          </div>
        </Card.Body>
      </Card>

      <Tabs activeKey={currentTab} onSelect={(k) => setCurrentTab(k)} className="mb-4">
        <Tab eventKey="summary" title="Summary">
          <Card className="mb-4 p-3">
            <Card.Body className='p-0'>
              {selectedDocument && selectedDocument.fileUrl && (
                <h4 className="mb-3">
                  {decodeURIComponent(selectedDocument.fileUrl.split('/').pop().split('?')[0]).replace(/^\d+-/, '').replace(/\.[^/.]+$/, "")}
                </h4>
              )}
              <ReactMarkdown
                components={{
                  h1: ({ node, ...props }) => (
                    <h1 className="mt-4 mb-3" style={{ fontSize: '20px', fontWeight: 'bold' }} {...props} />
                  ),
                  h2: ({ node, ...props }) => (
                    <h2 className="mt-3 mb-2" style={{ fontSize: '18px', fontWeight: 'bold' }} {...props} />
                  ),
                  h3: ({ node, ...props }) => (
                    <h3 className="fw-bold mb-2" style={{ fontSize: '16px' }} {...props} />
                  ),
                  h4: ({ node, ...props }) => (
                    <h4 className="mb-2" style={{ fontSize: '14px' }} {...props} />
                  ),
                  h5: ({ node, ...props }) => (
                    <h5 className="mb-2" style={{ fontSize: '13px' }} {...props} />
                  ),
                  h6: ({ node, ...props }) => (
                    <h6 className="mb-2" style={{ fontSize: '12px' }} {...props} />
                  ),
                  ul: ({ node, ...props }) => (
                    <ul className="ps-4 mb-3" {...props} />
                  ),
                  ol: ({ node, ...props }) => (
                    <ol className="ps-4 mb-3" {...props} />
                  ),
                  li: ({ node, ...props }) => (
                    <li className="mb-1" style={{ lineHeight: '1.5' }} {...props} />
                  ),
                  p: ({ node, ...props }) => (
                    <p className="mb-2" style={{ lineHeight: '1.6', color: '#212529' }} {...props} />
                  )
                }}
              >
                {analysisData.markdown}
              </ReactMarkdown>
            </Card.Body>
          </Card>
        </Tab>
        <Tab eventKey="flagged" title="Flagged Points">
          <div>
            {Array.isArray(flaggedPointsData) && flaggedPointsData.length > 0 ? (
              // Structured display for parsed flagged points
              flaggedPointsData.map((riskCategory, index) => (
                <Card key={index} className="mb-4 p-3">
                  <div className="d-flex align-items-center mb-3">
                    <div className="text-danger me-2">
                      <img src={IconExcel} alt="risk-icon" width={20} height={20} />
                    </div>
                    <h5 className="mb-0 text-primary fw-bold">{riskCategory.category}</h5>
                  </div>
                  <Card.Body className='p-0'>
                    <div className="list-group list-group-flush">
                      {riskCategory.items && riskCategory.items.map((item, i) => (
                        <div key={i} className="list-group-item border-0 px-0 py-2 markdown-container">
                          <div className="d-flex align-items-start">
                            {/* <div className="text-danger me-2 mt-1 flex-shrink-0">
                              <div
                                className="rounded-circle bg-danger"
                                style={{ width: '6px', height: '6px' }}
                              ></div>
                            </div> */}
                            <div className="text-dark flex-grow-1">
                              <ReactMarkdown
                                components={{
                                  p: ({ node, ...props }) => <p className="mb-1" {...props} />,
                                  strong: ({ node, ...props }) => <strong className="text-dark fw-bold" {...props} />,
                                }}
                              >
                                {item}
                              </ReactMarkdown>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Card.Body>
                </Card>
              ))
            ) : analysisData && analysisData.rawFlaggedPoints ? (
              // Direct display of raw flagged points with better markdown handling
              <div>
                <Card className="mb-4 p-3">
                  <Card.Body className='p-0'>
                    <ReactMarkdown
                      components={{
                        h1: ({ node, ...props }) => <h4 className="text-primary fw-bold mt-4 mb-3" {...props} />,
                        h2: ({ node, ...props }) => (
                          <div className="mt-4 mb-3">
                            <div className="d-flex align-items-center">
                              <div className="text-danger me-2">
                                <img src={IconExcel} alt="risk-icon" width={20} height={20} />
                              </div>
                              <h5 className="mb-0 text-primary fw-bold" {...props} />
                            </div>
                          </div>
                        ),
                        h3: ({ node, ...props }) => <h6 className="text-primary fw-bold mt-3 mb-2" {...props} />,
                        ul: ({ node, ...props }) => <ul className="ps-4 mb-3" {...props} />,
                        ol: ({ node, ...props }) => <ol className="ps-4 mb-3" {...props} />,
                        li: ({ node, ...props }) => (
                          <li className="mb-2 d-flex align-items-start" {...props}>
                            <div className="text-danger me-2 mt-1 flex-shrink-0">
                              <div
                                className="rounded-circle bg-danger"
                                style={{ width: '4px', height: '4px' }}
                              ></div>
                            </div>
                            <div className="flex-grow-1">{props.children}</div>
                          </li>
                        ),
                        p: ({ node, ...props }) => <p className="mb-2 text-dark" {...props} />,
                        strong: ({ node, ...props }) => <strong className="text-dark fw-bold" {...props} />,
                      }}
                    >
                      {analysisData.rawFlaggedPoints}
                    </ReactMarkdown>
                  </Card.Body>
                </Card>
              </div>
            ) : (
              // Fallback message
              <div className="text-center py-5">
                <div className="text-muted">
                  <img src={IconExcel} alt="no-risks" width={48} height={48} className="mb-3 opacity-50" />
                  <p>No flagged points detected in this document.</p>
                </div>
              </div>
            )}
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

export default AnalysisResults;